import React, { FC } from "react";

import { IgIconButton, IgSelect } from "@intelligems/ig-theme";
import { Grid, MenuItem, SelectChangeEvent, TextField } from "@mui/material";

import {
  TRAFFIC_CONFIG_FILTER_OPTIONS,
  TRAFFIC_CONFIG_QUERY_PARAM_OPTIONS,
} from "../targeting/utils/constants";

interface UrlParamFilterProps {
  urlParam?: {
    queryParam?: string | null;
    queryParamValue?: string | null;
    queryParamFilterType?: string | null;
  } | null;
  onReset: () => void;
  onUrlParamChange: (
    value: string,
    key: "queryParam" | "queryParamFilterType" | "queryParamValue"
  ) => void;
}
export const UrlParamFilter = ({
  urlParam,
  onUrlParamChange,
  onReset,
}: UrlParamFilterProps) => {
  return (
    <Grid container direction={"column"} rowSpacing={1}>
      <Grid
        item
        container
        direction={"row"}
        // justifyContent={"space-between"}
        alignItems={"center"}
        columnSpacing={1}
        wrap={"nowrap"}
      >
        <Grid item xs={3.5}>
          <IgSelect
            sx={{ width: "100%" }}
            variant={"outlined"}
            // sx={{ width: "160px" }}
            key={`query-param-key`}
            value={urlParam?.queryParam || ""}
            onChange={(e: SelectChangeEvent<any>) => {
              onUrlParamChange(e.target.value, "queryParam");
            }}
          >
            {Object.entries({
              ...TRAFFIC_CONFIG_QUERY_PARAM_OPTIONS,
            }).map(([key, value]) => (
              <MenuItem key={`query-param-key-${key}`} value={key}>
                {value}
              </MenuItem>
            ))}
          </IgSelect>
        </Grid>
        <Grid item xs={3.5}>
          <IgSelect
            sx={{ width: "100%" }}
            variant={"outlined"}
            // sx={{ width: "190px" }}
            value={urlParam?.queryParamFilterType || ""}
            onChange={(e) => {
              onUrlParamChange(
                e.target.value as string,
                "queryParamFilterType"
              );

              // setResource((draft) => {
              //   draft.filter = e.target.value as TrafficConfigFilter;
              //   if (
              //     e.target.value === "isNull" ||
              //     e.target.value === "isNotNull"
              //   ) {
              //     draft.value = "N/A";
              //   }
              //   return draft;
              // });
            }}
          >
            {Object.entries(TRAFFIC_CONFIG_FILTER_OPTIONS).map(
              ([key, value]) => (
                <MenuItem key={`query-param-filter-${key}`} value={key}>
                  {value}
                </MenuItem>
              )
            )}
          </IgSelect>
        </Grid>
        <Grid item xs={3.5}>
          <TextField
            sx={{ width: "100%" }}
            value={urlParam?.queryParamValue || ""}
            variant={"outlined"}
            disabled={
              urlParam?.queryParamFilterType === "isNotNull" ||
              urlParam?.queryParamFilterType === "isNull"
            }
            onChange={(e) => {
              onUrlParamChange(e.target.value as string, "queryParamValue");
            }}
          />
        </Grid>
        <Grid item xs={1}>
          <IgIconButton
            onClick={onReset}
            sx={{ width: "100%" }}
            iconType={"clear"}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
